import { getUsers, type User } from "./user.service";

// Pagina a base inteira de usuários do client — telas que precisam da lista
// completa (não paginada), como o vínculo de papéis e a troca de responsável.
export async function fetchAllUsers(): Promise<User[]> {
  const pageSize = 200;
  const first = await getUsers({ limit: pageSize, offset: 0 });
  const total = first.total ?? 0;
  if (total <= pageSize) return first.users ?? [];
  const pages = await Promise.all(
    Array.from({ length: Math.ceil((total - pageSize) / pageSize) }, (_, i) =>
      getUsers({ limit: pageSize, offset: (i + 1) * pageSize })
    )
  );
  return [...(first.users ?? []), ...pages.flatMap((p) => p.users ?? [])];
}
